export const es = {
  'sign_in': 'Acceder',
  'sign_out': 'Cerrar sesión',
  'create_account': 'Crear cuenta',
  'search': 'Buscar',
  'searchByCity': 'Buscar por Ciudad',
  'searchPlaceholder': 'Buscar...',
  'searchChiapasPlaceholder': "Buscar ciudades en Chiapas...",
  'searchHidalgoPlaceholder': "Buscar ciudades en Hidalgo...",
  'home': 'Inicio',
  'regions': 'Regiones',
  'cities': 'Ciudades',
  'about': 'Acerca de',
  'contact': 'Contacto',
  'donate': 'Hacer una Donación',
  'missionaries': 'Misioneros',
  'churches': 'Iglesias',
  'churchPresence': 'Presencia de la Iglesia',
  'population': 'Población',
  'unreachedPeoples': 'Grupos de personas no alcanzados',
  'regionInfo': 'Información de la región',
  'fundingProgress': 'Progreso de financiación',
  'languages': 'Idiomas',
  'unreached': 'No alcanzado',
  'low': 'Baja',
  'medium': 'Mediana',
  'high': 'Alta',
  'unknown': 'Desconocido',
  'donationSuccessful': 'Promesa Exitosa',
  'donationSuccessMessage': '¡Gracias por tu promesa a {region}! Tu apoyo ayudará a marcar la diferencia.',
  'donationSuccessGeneric': '¡Gracias por tu promesa! Tu apoyo ayudará a marcar la diferencia.',
  'donationCanceled': 'Promesa Cancelada',
  'donationCanceledMessage': 'Tu promesa ha sido cancelada. Inténtalo de nuevo cuando quieras.',
  'clickToLearnMore': 'Haga clic para obtener más información',
  'resetFilters': 'Restablecer filtros',
  'all': 'Todos',
  'searchSpecialRegionsPlaceholder': 'Buscar en regiones especiales...',
  'resetView': "Restablecer Vista",
  'applyForFunding': 'Solicitar Financiamiento',
  'fundingDescription': 'Envía tu proyecto misionero para consideración de financiamiento',
  'fundingRequirements': 'Requisitos',
  'validProject': 'Propuesta válida de proyecto misionero',
  'detailedBudget': 'Desglose detallado del presupuesto',
  'timelineRequired': 'Cronograma del proyecto',
  'impactMetrics': 'Plan de medición de impacto',
  'startApplication': 'Iniciar Solicitud',
  'pledgeDescription': 'Apoyar el Trabajo Misionero en esta Ciudad',
  'cityName': 'Ciudad',
  'makePledge': 'Hacer una Promesa',
  'pledged': 'Prometido',
  'backToRegion': 'Volver a la Región',
  'backToCountry': 'Volver al País',
  'filters': 'Filtros',
  'specialRegionsOnly': 'Solo Chiapas y Hidalgo',
  'chiapasHeatmapTitle': 'Mapa de Calor de Presencia de Iglesias',
  'chiapasHeatmapDescription': 'Mostrando el mapa de calor de presencia de iglesias para la región de Chiapas. Las ciudades están coloreadas por su nivel de presencia de iglesias.',
  'hidalgoHeatmapTitle': 'Región de Hidalgo',
  'hidalgoHeatmapDescription': 'Mostrando el mapa de calor de presencia de iglesias para la región de Hidalgo con comunidades indígenas Otomí',
  'noResults': 'Sin resultados',
  'lessThan5Percent': 'Menos del 5% de presencia cristiana',
  'lessThan10Percent': 'Menos del 10% de presencia cristiana',
  'lessThan30Percent': 'Menos del 30% de presencia cristiana',
  'moreThan30Percent': 'Más del 30% de presencia cristiana',
  'legend': 'Clave',
  'pledgeSupport': 'Prometer Apoyo',
  'makeDonation': 'Hacer una Donación',
  'needed': 'Necesario',
};
